import { Col, Divider, Row, Typography, Tag } from "antd";
import constants from "../../../constants";
import { IDashboardResponse } from "../../../types/dashboard";
import { LightBlueContainer } from "../../styled/Container.styled";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import React from "react";

type PlaceCardProps = {
  heading?: string;
  data?: IDashboardResponse;
};

const PopularPlaceLightBlueContainer = styled(LightBlueContainer)`
  padding: 5px;
  border: none;
`;

const placeImage = {
  width: "100%",
  border: "1px solid #2b3e5d",
  borderRadius: "5px",
  aspectRatio: "2 / 1.5",
};

function PlaceCard(props: PlaceCardProps) {
  const { Text } = Typography;
  const { data, heading } = props;
  const navigate = useNavigate();

  const handlePopularPlaceClick = () => {
    navigate("/popularplaces");
  };

  return (
    <>
      <PopularPlaceLightBlueContainer>
        <Text className="dashboard-card-heading-text-size">{heading}</Text>
        <Row className="inner-white-place-container-style">
          {data?.data.popularPlaces.map((item) => (
            <React.Fragment key={item.placeName}>
              <Row
                gutter={[32, 22]}
                justify={"center"}
                style={{ cursor: "pointer" }}
                onClick={handlePopularPlaceClick}
              >
                <Col span={8}>
                  <Row>
                    <img
                      className="popular-place-image"
                      style={placeImage}
                      alt="place"
                      src={`${item.image}`}
                    />
                  </Row>
                </Col>

                <Col span={16}>
                  <Row gutter={[4, 18]}>
                    <Col span={24}>
                      <Text strong>{item.placeName}</Text>
                    </Col>
                    <Col span={24}>
                      <Text type="success">
                        {item.status === true ? (
                          <Tag color="success">Active</Tag>
                        ) : (
                          <Tag color="error">Inactive</Tag>
                        )}
                      </Text>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Divider style={{ margin: "5% 0%" }} />
            </React.Fragment>
          ))}
        </Row>
      </PopularPlaceLightBlueContainer>
    </>
  );
}

export default PlaceCard;
